import {LatLngExpression, Marker} from 'leaflet';
import {UnitMarkerOptions} from './UnitMarkerOptions';

export class UnitMarker extends Marker {
  constructor(latlng: LatLngExpression, options?: UnitMarkerOptions) {
    super(latlng, options);
  }
  options: UnitMarkerOptions;
}
